function menuDrawerSubMenu() {
  const subMenuElements = document.querySelectorAll('.menu-drawer__accordion');
  let activeSubmenu = document.querySelector('.menu-drawer__submenu.active--submenu');
  let activeParent = document.querySelector('.menu-drawer__parent.submenu-is-open');

  function toggleActiveState(menuTitle, submenu) {
    if (submenu === activeSubmenu) {
      menuTitle.setAttribute('aria-expanded', 'false');
      menuTitle.classList.remove('submenu-is-open');
      submenu.classList.remove('active--submenu');
      activeSubmenu = null;
      activeParent = null;
    } else {
      menuTitle.setAttribute('aria-expanded', 'true');
      menuTitle.classList.add('submenu-is-open');
      submenu.classList.add('active--submenu');
      activeSubmenu = submenu;
      activeParent = menuTitle;
    }
  }

  subMenuElements.forEach((elem) => {
    const submenu = elem.querySelector('.menu-drawer__submenu');
    const menuTitle = elem.querySelector('.menu-drawer__parent');

    menuTitle.addEventListener('click', () => {
      if (activeSubmenu && activeSubmenu !== submenu) {
        toggleActiveState(activeParent, activeSubmenu);
      }
      toggleActiveState(menuTitle, submenu);
    });
  });
}

menuDrawerSubMenu();

function mainNavHover() {
  const headerWrapper = document.querySelector('.header-wrapper');
  const menuItems = document.querySelectorAll('header-menu details');
  
  menuItems.forEach((menuItem) => {
    let closeTimer;
    const summary = menuItem.querySelector('summary');
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
    
    menuItem.addEventListener('mouseover', function() {
      clearTimeout(closeTimer);
      menuItem.open = true;
      summary.setAttribute('aria-expanded', true);
      headerWrapper.classList.add('mega-menu--open');
    });

    menuItem.addEventListener('mouseout', function(e) {
      closeTimer = setTimeout(function() {
       if (!menuItem.contains(e.relatedTarget)) {
        menuItem.open = false;
        summary.setAttribute('aria-expanded', false);
        let isAnyOtherOpen = Array.from(menuItems).some((item) => item.open);

        if (!isAnyOtherOpen) {
          headerWrapper.classList.remove('mega-menu--open');
         }
        }
      }, 300);
    });

    menuItem.addEventListener('focus', function() {
      menuItem.open = true;
      summary.setAttribute('aria-expanded', true);
      headerWrapper.classList.add('mega-menu--open');
    });
    
    menuItem.addEventListener('blur', function(e) {
      closeTimer = setTimeout(function() {
        if (!menuItem.contains(e.relatedTarget)) {
          menuItem.open = false;
          summary.setAttribute('aria-expanded', false);
          // Check if there is still any other open menu item
          let isAnyOtherOpen = Array.from(menuItems).some((item) => item.open);

          if (!isAnyOtherOpen) {
            headerWrapper.classList.remove('mega-menu--open');
          }
        }
      }, 500);
    });
  });
}

mainNavHover();

function headerOverlap() {
  const pageBannerWithOverlap = document.querySelector('.page-banner__header-overlap');
  if (pageBannerWithOverlap) {
    document.querySelector('.header-wrapper').style.backgroundColor = 'transparent';
    document.querySelector('.header').style.backgroundColor = 'transparent';
  }
}

headerOverlap();

